import Prismic from "@prismicio/client";
import { PRISMIC_ENDPOINT, PRISMIC_TOKEN } from "./config";

const Client = Prismic.client(PRISMIC_ENDPOINT!, {
  accessToken: PRISMIC_TOKEN,
});

export default Client;
